import styled from '@emotion/styled'
import { observer } from 'mobx-react-lite'
import { useRussianPokerStore } from 'providers/RussianPokerProvider'
import { FC, useState } from 'react'
import { Direction, Range, getTrackBackground } from 'react-range'

const STEP = 0.01
const MIN = 0
const MAX = 1
const DIRECTION: Direction = Direction.Up

const Container = styled.div`
  position: absolute;
  top: calc(100% + 12px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
`

const SliderWrapper = styled.div`
  height: 150px;
  display: flex;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(
      269deg,
      rgba(255, 255, 255, 0.1) 0.57%,
      rgba(255, 255, 255, 0.05) 31.35%
    ),
    rgba(0, 0, 0, 0.6);
  padding: 14px 10px;
  border-radius: 10px;
`

const Thumb = styled.div`
  height: 15px;
  width: 15px;
  border-radius: 50%;
  outline: none;
  background-color: ${({ theme }) => theme.rpTheme.colors.white};
`

export const VolumeSlider: FC = observer(() => {
  const {
    uiStore: { volume, setVolume },
  } = useRussianPokerStore()

  const [localVolume, setLocalVolume] = useState([volume])

  return (
    <Container data-volume-slider>
      <SliderWrapper>
        <Range
          step={STEP}
          min={MIN}
          max={MAX}
          values={localVolume}
          direction={DIRECTION}
          onChange={(values) => {
            setLocalVolume(values)
            setVolume(values[0])
          }}
          renderTrack={({ props, children }) => (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <div
              onMouseDown={props.onMouseDown}
              onTouchStart={props.onTouchStart}
              style={{
                ...props.style,
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
              }}>
              <div
                ref={props.ref}
                style={{
                  width: '12px',
                  height: '100%',
                  borderRadius: '30px',
                  background: getTrackBackground({
                    values: localVolume,
                    colors: ['#FFC445', 'rgba(255, 255, 255, 0.5)'],
                    min: MIN,
                    max: MAX,
                    direction: DIRECTION,
                  }),
                  alignSelf: 'center',
                }}>
                {children}
              </div>
            </div>
          )}
          renderThumb={({ props }) => {
            const { key, ...restProps } = props
            return (
              <Thumb
                key={key}
                {...restProps}
                style={{
                  ...restProps.style,
                }}
              />
            )
          }}
        />
      </SliderWrapper>
    </Container>
  )
})
